export default __webpack_public_path__ + "static/media/Painting-small.7548eae1.jpeg";